import type Owner from '@ember/owner';

import NoResultsBaseComponent, { type NoResultsBaseArgs } from 'webapp/components/no-results/base';

export default class NoResultsUsersComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.titleText = 'No users added yet';
		this.descText = 'Invite your team members to collaborate on your data.';
		this.readMoreUrl = 'https://help.databox.com/overview-user-management';
	}

	override get createButtonText() {
		return 'Invite teammate';
	}

	override get showDemoButton(): boolean {
		return false;
	}

	get showRequestHelp(): boolean {
		return false;
	}
}
